import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import ClickableDiv from '@Components/clickable-div/clickable-div';
import styles from './capture-image-button.module.scss';

interface CaptureImageButtonProps {
  onClick(): void;
  isOnMobile?: boolean;
}

export function CaptureImageButton({isOnMobile = false, ...props}: CaptureImageButtonProps): ReactElement | null {
  return (
    <div className={`${styles.wrapper} ${!isOnMobile ? styles.marginOnDesktop : styles.wrapperMobile} radius-round flex-center`}>
      <ClickableDiv
        onClick={(): void => {
          props.onClick();
        }}
        className={`${styles.button} hover-transition-all flex-center`}
      >
        <Icon icon="icon-camera" size={IconSize.SIZE_ICON_24} className="content-body-white" />
      </ClickableDiv>
    </div>
  );
}
